<template>
  <v-textarea
    v-if="!readonly"
    v-bind="{...$props, ...customData.props}"
    :class="customData.class"
    v-on="$listeners"
  >
    <slot />
  </v-textarea>
  <w-read-only-text-field
    v-else
    v-bind="$props"
    v-on="$listeners"
  >
    <slot />
  </w-read-only-text-field>
</template>

<script>
import { VTextarea } from "vuetify/lib";
import isRequired from "@/mixins/component/is-required-mixin";
import pendingAble from "@/mixins/component/pending-able-mixin";
import { getRequiredLabelProp } from '@/components/global_components/forms/utils/required-label-util';

export default {
  name: "WorkTextArea",
  mixins: [isRequired, pendingAble],
  props: {
    ...VTextarea.options.props,
  },
  computed: {
    customData() {
      const mobileProps = {
        autoGrow: this.$vuetify?.breakpoint?.xsOnly ?? false,
        rows:this.$vuetify?.breakpoint?.xsOnly ? '2' : this.$props.rows
      }
    
      return {
        class: [
          { 'w-text-area--input--has-label': this.$props.label },
          this.$attrs.class
        ],
        props: {
          outlined: true,
          hideDetails: 'auto',
          ...getRequiredLabelProp(this.$props),
          ...mobileProps
        },
      };
    }
  }
};
</script>

<style lang="scss">
.w-text-area--input--has-label {
  & > .v-input__control {
    padding-top: 0.25rem;
    textarea,label {
      font-size: 1rem;
    }

    & > .v-input__slot {
      & > .v-input__prepend-inner {
        z-index: 7;
      }
    }
  }
}
</style>
